import { RolePermissionMapping } from '@traton/devportal-rbac-common-lib';

import { announcementAdmin } from './roles';
import {
  announcementReadPermission,
  announcementCreatePermission,
  announcementUpdatePermission,
  announcementDeletePermission,
} from './permissions';

export const roleMapping: RolePermissionMapping = new Map([
  [
    announcementAdmin,
    [
      announcementReadPermission,
      announcementCreatePermission,
      announcementUpdatePermission,
      announcementDeletePermission,
    ],
  ],
]);
